.root {
  &[data-variant='sidebar'] {
    border-radius: 4px;
    font-weight: 500;
    font-size: var(--mantine-fontSizes-sm);
    color: var(--mantine-color-gray-9);
    padding: 4px;
    gap: 6px;

    &[data-active] {
      background-color: var(--mantine-color-brand-3);
      color: var(--mantine-color-gray-8);
      font-weight: 700;
    }

    &[data-level='0'] {
      font-size: var(--mantine-fontSizes-textLg);
      font-weight: 600;
      color: var(--mantine-color-gray-10);
    }

    &[data-level]:not([data-level='0']) {
      font-size: var(--mantine-fontSizes-textMd);
      font-weight: 600;
      color: var(--mantine-color-gray-8);
    }
  }
}
